import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import ReplayIcon from '@material-ui/icons/Replay';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { Store, useAppDispatch } from 'src/redux/Store';
import { PAYMENT_STATUS, PAYMENT_TYPE, PaymentModel } from 'src/models/PaymentModel';
import { DIALOGS } from 'src/models/DialogModel';
import { openDialog } from 'src/redux/actions/dialogActions';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';

interface OwnProps {
  payment: PaymentModel;
}

type Props = OwnProps & ButtonProps;

const RetryUserPaymentButton = (props: Props) => {
  const { disabled, payment } = props;
  const dispatch = useAppDispatch();
  const lang = useSelector((state: Store) => state.language.language);

  const isRetryable = () => {
    if (!payment) return false;
    const isErrorOrDeclined = [PAYMENT_STATUS.declined, PAYMENT_STATUS.error]
      .includes(payment.payment_status as PAYMENT_STATUS);
    const isOnline = [PAYMENT_TYPE.cc, PAYMENT_TYPE.eft]
      .includes(payment.payment_type as PAYMENT_TYPE);
    return isErrorOrDeclined && isOnline;
  };

  if (!isRetryable()) return null;

  const handleOpen = () => {
    dispatch(openDialog({
      dialog: DIALOGS.retryUserPayment,
      payload: payment,
    }));
  };

  return (
    <Tooltip
      title={t(lang, 'menus.retry_payment')}
      placement="top-start">
      <span>
        <ActionButton
          variant="outlined"
          category={MENU_BUTTON_CATEGORY.action}
          onClick={handleOpen}
          disabled={disabled}>
          <ReplayIcon />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default RetryUserPaymentButton;
